// src/store/slices/counterSlice.js

import { createSlice } from '@reduxjs/toolkit';

// const counterSlice = createSlice({
//   name: 'counter',
//   initialState: {
//     value: 0,
//   },
//   reducers: {
//     increment: (state) => {
//       state.value += 1;
//     },
//     decrement: (state) => {
//       state.value -= 1;
//     },
//   },
// });


// export const { increment, decrement } = counterSlice.actions;
// export default counterSlice.reducer;

const counterSlice = createSlice({
  name: 'counter',
  initialState: {
    value: 0,
    wishlistValue: 0,
  },
  reducers: {
    increment: (state) => {
      state.value += 1;
    },
    decrement: (state) => {
      state.value -= 1;
    },
    setCount: (state, action) => {
      state.value = action.payload;
    },
    setWishlistCount: (state, action) => {
      state.wishlistValue = action.payload;
    },
  },
});

export const { increment, decrement, setCount, setWishlistCount } = counterSlice.actions;
export default counterSlice.reducer;


